<template>
    <tr class="report__list_table_item_collapse_table_item">
        <td class="report__list_table_item_collapse_table_item_date">
            {{ scheduledReportPlanned }}
        </td>
        <td class="report__list_table_item_collapse_table_item_status">
            <component-status :status="scheduledReportStatus"></component-status>
        </td>
        <td class="report__list_table_item_collapse_table_item_actions">
            <div class="columns is-variable">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :name="'report-list-table-item-collapse-table-item-view'"
                        :theme="'default'"
                        :disabled="scheduledReportStatus !== 'success'"
                        @click='redirectToReportExecute'
                    >View
                    </component-button>
                </div>
                <div class="column is-narrow">
                    <component-button
                        :name="'report-list-table-item-collapse-table-item-download-csv'"
                        :theme="'default'"
                        :animate-loading="true"
                        :animate-loading-event-name="'generate-scheduled-csv'"
                        :disabled="scheduledReportStatus !== 'success'"
                        @click="performGenerateCSV"
                    >Download CSV
                    </component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>

import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { toLocaleDateTime } from '@/functions'

export default {
  name: 'report-list-table-item-collapse-table-item',
  components: { ComponentStatus, ComponentButton },
  props: {
    item: {
      type: Object,
      required: true
    },
    reportData: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    reportId () {
      return this.reportData.id
    },
    reportName () {
      return this.reportData.name
    },
    scheduledReportId () {
      return this.item.id
    },
    scheduledReportStatus () {
      return this.item.status
    },
    scheduledReportPlanned () {
      return this.item.plannedExecutionDate ? toLocaleDateTime(this.item.plannedExecutionDate) : undefined
    },
    scheduledReportExecutedAt () {
      return this.item.executedAt ? toLocaleDateTime(this.item.executedAt) : undefined
    }
  },
  methods: {
    performGenerateCSV () {
      this.csvRequestPending = true
      this.$store.dispatch('ebsReportBuilderGenerateScheduledReportCSV', {
        reportId: this.reportId,
        reportName: this.reportName,
        resultId: this.scheduledReportId
      }).finally(() => {
        this.csvRequestPending = false
        this.$eventBus.$emit('stop-generate-scheduled-csv')
      })
    },
    redirectToReportExecute () {
      this.$router.push({ name: 'ebs-report-builder-execute-scheduled', params: { reportId: this.reportId, resultId: this.scheduledReportId } })
    }
  }
}
</script>
